import { SHMChannelData, SHMChannelType } from "../interfaces/shm.interface";
import { MeasurementWindow, RemovedPoint } from "../interfaces/measurement-edit-state.interface";

class CorrosionData {
  time?: Date;
  last_ice?: number;
  quality?: number;
  humidity?: number;
  potential?: number;
  rp?: number;
  rohm?: number;
  temperature?: number;
}

export class Measurement {
  _id?: string;
  name?: string;
  description?: string;
  owner?: string;
  measurementType?: string;
  shared_w?: string[];
  shared_r?: string[];
  project?: any;
  stage?: any;
  concrete?: string;
  device?: string;
  active?: boolean;
  started?: boolean;
  maturity?: number[];
  strength?: number[];
  time?: Date[];
  temperature?: number[];
  timeAll?: Date[];
  temperatureAll?: number[];
  createdAt?: Date;
  updatedAt?: Date;
  company?: any;
  report?: string;
  specifications?: number[];
  specifications_maturity?: number[];
  curingPoolData?: {temperature: number[], time: Date[]}[];
  curingPoolFinished?: boolean;
  specifications_maturity_relative?: number[];
  // CORROSION SAFECOR MOTA
  data?: {
    electrode1: {
        allData: CorrosionData[],
        rangeData: CorrosionData[]
    },
    electrode2: {
        allData: CorrosionData[],
        rangeData: CorrosionData[]
    }
  }
  // STRUCTURAL HEALTH MONITORING
  // `name` is an optional user-facing label for the channel; the map key
  // (`channel1`, `channel2`, …) stays the immutable hardware wiring address the
  // ingest pipeline writes against. Charts / CSV fall back to the key when unset.
  dataChannels?: Map<string, { type: SHMChannelType, parameters: any, name?: string }>;
  channelData?: { [channelId: string]: Partial<SHMChannelData> };
  channelDataAll?: { [channelId: string]: Partial<SHMChannelData> };

  // Phase 1 (2026-09-07): shared time-series projection model — see ADR 0018.
  window?: MeasurementWindow | null;
  removedPoints?: RemovedPoint[];
}

// TODO: CREATE INDIVIDUAL MODELS FOR EACH MEASUREMENT TYPES ONLY WITH THEIR OWN FIELDS
